import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@teach/ui'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import betaAuthor from '@/assets/author-badges/beta-author.png'
import verifiedAuthor from '@/assets/author-badges/verified-author.png'

interface Props {
  /** Доступ в бету. */
  beta: boolean
  /** Проверенный автор (админ). */
  verified: boolean
  /** `sm` — рядом с мелким текстом (меню), `lg` — рядом с крупным ником (профиль). */
  size?: 'sm' | 'lg'
  className?: string
}

const Badge = ({ src, label, size }: { src: string; label: string; size: 'sm' | 'lg' }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <img
        src={src}
        alt={label}
        draggable={false}
        className={cn('shrink-0 rounded-[22%] object-cover', size === 'lg' ? 'size-7' : 'size-4')}
      />
    </TooltipTrigger>
    <TooltipContent side="top">{label}</TooltipContent>
  </Tooltip>
)

/** Статусы автора значками: подпись — по наведению. */
export const AuthorBadges = ({ beta, verified, size = 'sm', className }: Props) => {
  const m = useMessages(messages)
  if (!beta && !verified) return null
  return (
    <TooltipProvider delayDuration={150}>
      <span className={cn('inline-flex items-center gap-1.5', className)}>
        {/* Один статус, а не два: проверенный автор уже не бета. */}
        {verified ? (
          <Badge src={verifiedAuthor} label={m.verifiedAuthor} size={size} />
        ) : (
          <Badge src={betaAuthor} label={m.betaAuthor} size={size} />
        )}
      </span>
    </TooltipProvider>
  )
}
